function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { closeModal } from "@common/actions";
import { Button, Card, CardContent, CardHeader, Typography } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
var PinModal = /*#__PURE__*/ function(_React_PureComponent) {
    "use strict";
    _inherits(PinModal, _React_PureComponent);
    var _super = _create_super(PinModal);
    function PinModal(props) {
        _class_call_check(this, PinModal);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "onStop", function() {
            var _this_props = _this.props, onStop = _this_props.onStop, _$closeModal = _this_props.closeModal;
            onStop && onStop();
            _$closeModal();
        });
        _define_property(_assert_this_initialized(_this), "onContinue", function() {
            var _this_props = _this.props, onContinue = _this_props.onContinue, _$closeModal = _this_props.closeModal;
            onContinue && onContinue();
            _$closeModal();
        });
        _define_property(_assert_this_initialized(_this), "renderTitle", function() {
            var i18n = _this.props.i18n;
            return /*#__PURE__*/ _jsxs("div", {
                style: {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 4
                },
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        style: {
                            paddingRight: 7
                        },
                        src: "common/assets/media/ic-warning.svg"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h4",
                        className: "subtitle",
                        color: "text.secondary",
                        style: {
                            fontWeight: "bold"
                        },
                        children: i18n.errors.limitModalTitle
                    })
                ]
            });
        });
        _this.pinModalStyle = {
            overflow: "hidden",
            position: "fixed",
            width: "100%",
            height: "100%"
        };
        return _this;
    }
    _create_class(PinModal, [
        {
            key: "render",
            value: function render() {
                var i18n = this.props.i18n;
                return /*#__PURE__*/ _jsx("div", {
                    className: "modal-overlay",
                    style: this.pinModalStyle,
                    children: /*#__PURE__*/ _jsxs(Card, {
                        style: {
                            maxWidth: 476,
                            width: "100%",
                            minHeight: 362,
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(CardHeader, {
                                title: this.renderTitle(),
                                style: {
                                    paddingTop: 40,
                                    paddingRight: 56,
                                    paddingLeft: 56
                                }
                            }),
                            /*#__PURE__*/ _jsxs(CardContent, {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    position: "relative",
                                    flex: 1,
                                    gap: 20,
                                    paddingRight: 56,
                                    paddingLeft: 56
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "h5",
                                        className: "subtitle",
                                        gutterBottom: true,
                                        color: "text.secondary",
                                        children: i18n.errors.limitModalDesc1
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "h5",
                                        style: {
                                            fontWeight: "bold"
                                        },
                                        className: "title",
                                        gutterBottom: true,
                                        color: "text.secondary",
                                        children: i18n.errors.limitModalDesc2
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "modal-footer",
                                        style: {
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "flex-start",
                                            height: 75,
                                            paddingBottom: 40
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(Button, {
                                                classes: {
                                                    label: "ux-button-label"
                                                },
                                                variant: "text",
                                                className: "go-back-button raised half-width",
                                                onClick: this.onStop,
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: i18n.errors.limitModalStop
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                style: {
                                                    backgroundColor: "#5d9fd8",
                                                    color: "white",
                                                    minWidth: 180,
                                                    fontSize: "1.4rem",
                                                    fontWeight: 400,
                                                    boxShadow: "none"
                                                },
                                                variant: "contained",
                                                onClick: this.onContinue,
                                                children: i18n.errors.limitModalContinue
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return PinModal;
}(React.PureComponent);
var mapStateToProps = function(param) {
    var i18n = param.i18n;
    return {
        i18n: i18n
    };
};
export default connect(mapStateToProps, {
    closeModal: closeModal
})(PinModal);
